export {default as BeWizrMeetingDocument} from './BeWizrMeetingDocument'